import React, { memo, useCallback } from 'react';
import cn from 'classnames';

import styles from './styles.module.scss';

type CheckboxProps = {
  isChecked: boolean;
  onChange: (isChecked: boolean) => void;
  label?: string | JSX.Element;
  classNameContainer?: string;
  isRegisterPage?: boolean;
};

export const Checkbox = memo<CheckboxProps>(({
  onChange,
  label,
  isChecked,
  classNameContainer,
  isRegisterPage,
}) => {
  const onChangeHandler = useCallback(() => {
    onChange(!isChecked);
  }, [onChange, isChecked]);

  return (
    <div
      className={cn(
        styles.checkbox_container, 
        classNameContainer, 
        { [styles.checkbox_container_register]: isRegisterPage },
      )}
    >
      <button
        className={cn(
          styles.checkbox,
          { [styles.checkbox_checked]: isChecked },
        )}
        onClick={onChangeHandler}
        type="button"
        aria-label="checkbox"
      >
        <div className={cn(styles.checkbox_icon, { [styles.checkbox_icon_checked]: isChecked })} />
      </button>

      {label !== undefined && <div className={styles.label}>{label}</div>}
    </div>
  );
});
